<template>
  <div>
    <div class="main">
      <section class="app-main">
        <transition name="fade-transform" mode="out-in">
          <!-- <router-view :key="key" /> -->

          <keep-alive :include="cachedViews">
            <router-view :key="key" />
          </keep-alive>
        </transition>
      </section>

      <div class="version">
        <div class="date">V2.0.0 &nbsp;&nbsp; 深圳市放射沙龙科技有限公司 Copyright © 2023</div>
        <!-- <div class="company"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
}
.app-main {
  // min-height: calc(100vh - 84px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
.el-main {
  overflow-x: hidden;
}
.version {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #6380a1;
  .date,
  .company {
    margin-top: 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/components/AppMain.vue